import { BarChart, Bar, LineChart, Line, AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, Legend } from "recharts";
import { FONTS, COLORS } from "../constants/theme";

// ─── ForecastIQ ───────────────────────────────────────────────────────────────────
// Persona: CRO / Finance
// Data sources: See constants/modules.js

const KPIs = [
  { label: "Forecast Accuracy", value: "94%", delta: "Last 4 qtrs avg", color: "#059669" },
  { label: "Q3 Commit", value: "$4.2M", delta: "High confidence", color: "#059669" },
  { label: "Best Case", value: "$5.1M", delta: "Upside scenario", color: "#059669" },
  { label: "Pipeline Cover", value: "3.4x", delta: "vs quota", color: "#059669" },
  { label: "Avg Deal Risk", value: "28%", delta: "Weighted", color: "#d97706" },
  { label: "Slippage Rate", value: "18%", delta: "-4pts QoQ", color: "#059669" }
];
const CHART_DATA = [
  {
    "week": "W1",
    "Commit": 1.2,
    "BestCase": 1.8,
    "Quota": 3.5
  },
  {
    "week": "W2",
    "Commit": 1.8,
    "BestCase": 2.6,
    "Quota": 3.5
  },
  {
    "week": "W3",
    "Commit": 2.5,
    "BestCase": 3.4,
    "Quota": 3.5
  },
  {
    "week": "W4",
    "Commit": 3.1,
    "BestCase": 4.0,
    "Quota": 3.5
  },
  {
    "week": "W5",
    "Commit": 3.6,
    "BestCase": 4.6,
    "Quota": 3.5
  },
  {
    "week": "W6",
    "Commit": 4.2,
    "BestCase": 5.1,
    "Quota": 3.5
  }
];

export default function ForecastIQ({ module: mod, theme }) {
  const { surface, border, text, muted, dark } = theme;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>

      {/* KPI Grid */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 12 }}>
        {KPIs.map((k, i) => (
          <div key={i} style={{ background: surface, border: `1px solid ${border}`, borderRadius: 12, padding: "16px 18px", position: "relative", overflow: "hidden" }}>
            <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: 2, background: `linear-gradient(90deg, ${mod.accent}55, ${mod.accent})` }} />
            <p style={{ color: muted, fontSize: 10, fontFamily: FONTS.mono, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 6 }}>{k.label}</p>
            <p style={{ fontFamily: FONTS.display, fontWeight: 800, fontSize: 22, color: text, letterSpacing: "-.02em" }}>{k.value}</p>
            <span style={{ display: "inline-block", marginTop: 6, fontFamily: FONTS.mono, fontSize: 10, padding: "2px 7px", borderRadius: 20, color: k.color, background: k.color + "18" }}>{k.delta}</span>
          </div>
        ))}
      </div>

      {/* Chart */}
      <div style={{ background: surface, border: `1px solid ${border}`, borderRadius: 14, padding: "20px 24px" }}>
        <p style={{ fontFamily: FONTS.mono, fontSize: 11, color: muted, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 16 }}>Forecast Scenarios vs. Quota ($M)</p>
        <ResponsiveContainer width="100%" height={240}>
          <LineChart data={CHART_DATA}>
          <CartesianGrid strokeDasharray="3 3" stroke="#1e243860" />
          <XAxis dataKey="week" tick={{ fill: "#8892b0", fontSize: 11 }} />
          <YAxis tick={{ fill: "#8892b0", fontSize: 11 }} />
          <Tooltip contentStyle={{ background: "#0a0e1a", border: "1px solid #1e2438", borderRadius: 8, fontSize: 11 }} />
          <Legend wrapperStyle={{ fontSize: 11, color: "#8892b0" }} />
          <Line type="monotone" dataKey="Commit" stroke="#7c3aed" strokeWidth={2} dot={{r:3}} />
          <Line type="monotone" dataKey="BestCase" stroke="#a78bfa" strokeWidth={2} dot={{r:3}} />
          <Line type="monotone" dataKey="Quota" stroke="#64748b" strokeWidth={2} dot={{r:3}} strokeDasharray="4 4"/>
        </LineChart>
        </ResponsiveContainer>
      </div>

      {/* Insight */}
      <div style={{ background: mod.accent + "10", border: `1px solid ${mod.accent}25`, borderRadius: 12, padding: "14px 18px", display: "flex", gap: 12, alignItems: "flex-start" }}>
        <span style={{ color: mod.accent, fontSize: 16, flexShrink: 0, marginTop: 1 }}>◉</span>
        <div>
          <p style={{ fontFamily: FONTS.mono, fontSize: 10, color: mod.accent, letterSpacing: ".08em", textTransform: "uppercase", marginBottom: 4 }}>IQ INSIGHT</p>
          <p style={{ fontSize: 13, color: dark ? "#a0aec0" : "#475569", lineHeight: 1.65 }}>Commit is tracking 20% above quota with 6 weeks remaining. Best case suggests significant upside if 3 late-stage deals close.</p>
        </div>
      </div>
    </div>
  );
}
